import { memo } from 'react';

import { EllipsisIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { DropdownMenuWithActionSheet } from '~/components/Menus/DropdownMenuWithActionSheet';
import { usePublicBoardHeaderMenuOptions } from '~/components/PublicBoard/usePublicBoardHeaderMenuOptions';
import { BOARD_ACTIONS_SUBMENU_BUTTON } from '~/constants/testIDs';

export const PublicBoardMoreOptionsButton = memo(() => {
  const { headerMenuOptions } = usePublicBoardHeaderMenuOptions();

  if (!headerMenuOptions.length) {
    return null;
  }

  return (
    <DropdownMenuWithActionSheet
      isTitleHidden
      options={headerMenuOptions}
      title="More options"
      trigger={
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          data-testid={BOARD_ACTIONS_SUBMENU_BUTTON}
          icon={EllipsisIcon}
          label="More options"
          size="large"
        />
      }
    />
  );
});

PublicBoardMoreOptionsButton.displayName = 'PublicBoardMoreOptionsButton';
